<template>
  <v-sheet class="wall-with-floor-background" height="100%">
    <v-row class="fill-height" align="center" justify="center">
      <v-col align="center" justify="center" :cols="columns">
        <!-- <BigButton text="View Fact Sheet" /> -->
        <v-img src="../../public/static/Easel Top.png" :width="easelTop" />

        <div @click="toggleDialog" style="cursor:pointer">
          <v-img src="https://streetcar-east.s3.us-east-2.amazonaws.com/projectHistory.png" contain width="95%" />
        </div>
        <v-img src="../../public/static/Easel Bottom.png" :width="easelBottom" />
      </v-col>
      <v-col :cols="columns" style="max-height: 85vh; overflow-y: auto;">
        <v-card class="slide-card" style="max-width: 90%;">
          <div class="slide-content">
            <!-- <h1 id="header">What is the Streetcar East Extension Project?</h1> -->
            <h1 id="header">What is the Streetcar East Extension Project?</h1>
            <p>
              The Streetcar East Extension project is the first extension of the
              existing downtown Streetcar, and originally opened in late 2014.
              This project runs along Edgewood Avenue to the BeltLine at Irwin
              Street and up to Ponce de Leon Avenue.
            </p>
            <p>
              In 2018, MARTA formally took on ownership of the existing downtown
              Streetcar and future expansions of the streetcar system. The
              Streetcar East Extension project is advancing based on a detailed
              review of the planning and design work prepared by Atlanta
              BeltLine, Inc. (ABI) on behalf of the City of Atlanta (COA).
              Preliminary engineering of this corridor continues to advance
              considering possible effects to adjacent properties, existing
              utilities, vehicle and operational needs, neighborhood
              accessibility, and proposed stop locations. This project has
              advanced with continued coordination with COA and ABI.
            </p>
            <p>
              <strong>
                Click the project timeline display and button to view fact sheet
                for more information.
              </strong>
            </p>
            <v-row justify="center" style="padding-top: 3%;padding-bottom: 5%;">
              <v-btn color="primary" dark class="buttons">
                <div @click="toggleDialogFAQ">
                  View Fact Sheet
                </div>
              </v-btn>
            </v-row>
            <v-row justify="center" style="padding-top: 3%;padding-bottom: 5%;">
              <v-btn color="primary" dark class="buttons" href="https://streetcar-east.s3.us-east-2.amazonaws.com/SCE+September+2022+Virtual+Public+Meeting+Presentation.pdf" target="_blank">
                <div>
                  Public Meeting Presentation
                </div>
              </v-btn>
            </v-row>
          </div>
        </v-card>
      </v-col>
    </v-row>
    <ImagePopup v-if="toggled" :close-modal="toggleDialog"
      image="https://streetcar-east.s3.us-east-2.amazonaws.com/projectHistory.png" />
    <ImagePopup v-if="toggledFAQ" :close-modal="toggleDialogFAQ"
      image="https://streetcar-east.s3.us-east-2.amazonaws.com/projectInfo.jpg" />
  </v-sheet>
</template>

<script>
import ImagePopup from "@/components/ImagePopup.vue";
// import BigButton from "@/components/BigButton.vue";

export default {
  name: "ProjectInformation",
  components: {
    ImagePopup
    // BigButton
  },
  data() {
    return {
      toggled: false,
      toggledFAQ: false,
      factSheetUrl:
        "https://streetcar-east.s3.us-east-2.amazonaws.com/projectInfo.jpg"
    };
  },
  computed: {
    easelTop() {
      if (this.$vuetify.breakpoint.xs) {
        return "25%";
      }
      return "10%";
    },
    easelBottom() {
      if (this.$vuetify.breakpoint.xs) {
        return "80%";
      }
      return "50%";
    },
    columns() {
      if (this.$vuetify.breakpoint.xs) {
        return 12;
      }
      return 6;
    }
  },
  methods: {
    toggleDialog() {
      this.toggled = !this.toggled;
    },
    toggleDialogFAQ() {
      this.toggledFAQ = !this.toggledFAQ;
    }
  }
};
</script>

<style scoped>
.myButton {
  box-shadow: 0px 1px 0px 0px #f0f7fa;
  background: linear-gradient(to bottom, #33bdef 5%, #019ad2 100%);
  background-color: #33bdef;
  border-radius: 15px;
  border: 1px solid #057fd0;
  display: inline-block;
  cursor: pointer;
  color: #ffffff;
  font-family: Arial;
  font-size: 1.5rem;
  font-weight: bold;
  padding: 6px 24px;
  text-decoration: none;
  text-shadow: 0px -1px 0px #5b6178;
  text-transform: uppercase;
}

.myButton:hover {
  background: linear-gradient(to bottom, #019ad2 5%, #33bdef 100%);
  background-color: #019ad2;
}

.myButton:active {
  position: relative;
  top: 1px;
}
</style>
